import Parse from 'html-react-parser';

function BMP20156(props) {
    let svgCode =
    `<svg width="56" height="76" viewBox="0 0 56 76" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="52" height="34" rx="3" transform="matrix(-1 0 0 1 54 2)" fill="${props.backgroundFill}"/>
        <rect width="52" height="34" rx="3" transform="matrix(-1 0 0 1 54 40)" fill="${props.backgroundFill}"/>
        <path d="M37.8787 58.489L38 48L27.3892 58.4272L37.8787 58.489Z" fill="${props.highlightColour}"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M26.286 52.4107C27.7509 52.2736 29.5765 52.8083 31.3304 54.7686L34.3114 52.1014C31.8154 49.3117 28.789 48.1589 25.9133 48.4281C23.0915 48.6922 20.6228 50.3124 19.204 52.646C17.7638 55.0146 17.4268 58.0782 18.7706 61.1313C20.099 64.1493 22.9786 66.9742 27.6311 69.234L29.3787 65.636C25.2811 63.6457 23.2628 61.4081 22.4317 59.5199C21.616 57.6668 21.858 55.9803 22.6218 54.724C23.407 53.4326 24.7673 52.5528 26.286 52.4107Z" fill="${props.highlightColour}"/>
        <path d="M37.8738 20.054L37.9951 9.565L27.3843 19.9922L37.8738 20.054Z" fill="${props.darkFill}"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M26.2812 13.9757C27.746 13.8386 29.5716 14.3733 31.3256 16.3336L34.3066 13.6664C31.8105 10.8768 28.7841 9.72393 25.9084 9.99308C23.0866 10.2572 20.6179 11.8774 19.1991 14.211C17.759 16.5796 17.4219 19.6432 18.7657 22.6963C20.0941 25.7143 22.9737 28.5392 27.6262 30.799L29.3738 27.201C25.2763 25.2107 23.2579 22.9731 22.4268 21.0849C21.6111 19.2318 21.8531 17.5453 22.617 16.289C23.4022 14.9976 24.7625 14.1178 26.2812 13.9757Z" fill="${props.darkFill}"/>
    </svg>`

    props.svgReturn(74, svgCode, "bmp00156", 56, 76);

    const style = {
        display: props.display
    }

    return (
        <div style={style}>
            {Parse(svgCode)}
        </div>
    );
}

export default BMP20156;